var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.687,
    height: 20.687,
    viewBox: "0 0 20.687 20.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 10.343,
    cy: 10.343,
    rx: 10.343,
    ry: 10.343,
    fill: "#50af95"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_149",
    "data-name": "Gruppe 149",
    transform: "translate(-686.157 -510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_148",
    "data-name": "Gruppe 148",
    transform: "translate(686.157 510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_105",
    "data-name": "Gruppe 105"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 10.343,
    cy: 10.343,
    rx: 10.343,
    ry: 10.343,
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_104",
    "data-name": "Gruppe 104",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_443",
    "data-name": "Pfad 443",
    d: "M-486.653,54.048l4.958,7.081h-4.958Z",
    transform: "translate(486.653 -40.442)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_444",
    "data-name": "Pfad 444",
    d: "M-486.653,52.086l5.114,7.3h-.156l-4.958-7.081Z",
    transform: "translate(486.653 -38.703)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_445",
    "data-name": "Pfad 445",
    d: "M-486.653,50.123l5.27,7.527h-.156l-5.114-7.3Z",
    transform: "translate(486.653 -36.963)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_446",
    "data-name": "Pfad 446",
    d: "M-486.653,48.161l5.427,7.75h-.156l-5.27-7.527Z",
    transform: "translate(486.653 -35.224)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_447",
    "data-name": "Pfad 447",
    d: "M-486.653,46.2l5.583,7.973h-.156l-5.427-7.75Z",
    transform: "translate(486.653 -33.485)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_448",
    "data-name": "Pfad 448",
    d: "M-486.653,44.237l5.739,8.2h-.156l-5.583-7.973Z",
    transform: "translate(486.653 -31.746)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_449",
    "data-name": "Pfad 449",
    d: "M-486.653,42.275l5.9,8.419h-.156l-5.739-8.2Z",
    transform: "translate(486.653 -30.007)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_450",
    "data-name": "Pfad 450",
    d: "M-486.653,40.312l6.051,8.642h-.156l-5.9-8.419Z",
    transform: "translate(486.653 -28.268)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_451",
    "data-name": "Pfad 451",
    d: "M-486.653,38.35l6.208,8.865h-.156l-6.051-8.642Z",
    transform: "translate(486.653 -26.529)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_452",
    "data-name": "Pfad 452",
    d: "M-486.653,36.388l6.364,9.088h-.156l-6.208-8.865Z",
    transform: "translate(486.653 -24.79)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_453",
    "data-name": "Pfad 453",
    d: "M-486.653,34.426l6.52,9.312h-.156l-6.364-9.088Z",
    transform: "translate(486.653 -23.05)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_454",
    "data-name": "Pfad 454",
    d: "M-486.653,32.464-479.977,42h-.156l-6.52-9.312Z",
    transform: "translate(486.653 -21.311)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_455",
    "data-name": "Pfad 455",
    d: "M-486.653,30.5l6.832,9.758h-.156l-6.676-9.535Z",
    transform: "translate(486.653 -19.572)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_456",
    "data-name": "Pfad 456",
    d: "M-486.653,28.539l6.989,9.981h-.156l-6.832-9.758Z",
    transform: "translate(486.653 -17.833)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_457",
    "data-name": "Pfad 457",
    d: "M-486.653,26.577l7.145,10.2h-.156l-6.989-9.981Z",
    transform: "translate(486.653 -16.094)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_458",
    "data-name": "Pfad 458",
    d: "M-486.653,24.615l7.3,10.427h-.156l-7.145-10.2Z",
    transform: "translate(486.653 -14.355)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_459",
    "data-name": "Pfad 459",
    d: "M-486.653,22.652-479.2,33.3h-.156l-7.3-10.427Z",
    transform: "translate(486.653 -12.616)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_460",
    "data-name": "Pfad 460",
    d: "M-486.653,20.69l7.614,10.873h-.156l-7.457-10.65Z",
    transform: "translate(486.653 -10.877)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_461",
    "data-name": "Pfad 461",
    d: "M-486.653,18.728l7.77,11.1h-.156l-7.614-10.873Z",
    transform: "translate(486.653 -9.137)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_462",
    "data-name": "Pfad 462",
    d: "M-486.653,16.766l7.926,11.319h-.156l-7.77-11.1Z",
    transform: "translate(486.653 -7.398)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_463",
    "data-name": "Pfad 463",
    d: "M-486.653,14.8l8.082,11.542h-.156l-7.926-11.319Z",
    transform: "translate(486.653 -5.659)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_464",
    "data-name": "Pfad 464",
    d: "M-486.653,12.841l8.238,11.766h-.156l-8.082-11.542Z",
    transform: "translate(486.653 -3.92)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_465",
    "data-name": "Pfad 465",
    d: "M-486.653,10.879l8.395,11.989h-.156L-486.653,11.1Z",
    transform: "translate(486.653 -2.181)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_466",
    "data-name": "Pfad 466",
    d: "M-486.653,8.917l8.551,12.212h-.156L-486.653,9.14Z",
    transform: "translate(486.653 -0.442)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_467",
    "data-name": "Pfad 467",
    d: "M-486.653,6.955l8.707,12.435h-.156l-8.551-12.212Z",
    transform: "translate(486.653 1.297)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_468",
    "data-name": "Pfad 468",
    d: "M-486.653,4.993l8.863,12.658h-.156l-8.707-12.435Z",
    transform: "translate(486.653 3.036)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_469",
    "data-name": "Pfad 469",
    d: "M-486.653,3.03l9.019,12.881h-.156l-8.863-12.658Z",
    transform: "translate(486.653 4.776)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_470",
    "data-name": "Pfad 470",
    d: "M-486.653,1.068l9.176,13.1h-.156l-9.019-12.881Z",
    transform: "translate(486.653 6.515)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_471",
    "data-name": "Pfad 471",
    d: "M-486.653-.894l9.332,13.327h-.156l-9.176-13.1Z",
    transform: "translate(486.653 8.254)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_472",
    "data-name": "Pfad 472",
    d: "M-486.653-2.856l9.488,13.55h-.156l-9.332-13.327Z",
    transform: "translate(486.653 9.993)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_473",
    "data-name": "Pfad 473",
    d: "M-486.653-4.819l9.644,13.773h-.156L-486.653-4.6Z",
    transform: "translate(486.653 11.732)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_474",
    "data-name": "Pfad 474",
    d: "M-486.653-6.781l9.8,14h-.156l-9.644-13.773Z",
    transform: "translate(486.653 13.471)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_475",
    "data-name": "Pfad 475",
    d: "M-486.653-8.743l9.957,14.22h-.156l-9.8-14Z",
    transform: "translate(486.653 15.21)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_476",
    "data-name": "Pfad 476",
    d: "M-486.653-10.705-476.54,3.737h-.156l-9.957-14.22Z",
    transform: "translate(486.653 16.949)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_477",
    "data-name": "Pfad 477",
    d: "M-486.653-12.667-476.384,2h-.156l-10.113-14.443Z",
    transform: "translate(486.653 18.689)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_478",
    "data-name": "Pfad 478",
    d: "M-486.653-14.63-476.228.259h-.156l-10.269-14.666Z",
    transform: "translate(486.653 20.428)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_479",
    "data-name": "Pfad 479",
    d: "M-486.653-16.592-476.072-1.48h-.156l-10.425-14.889Z",
    transform: "translate(486.653 22.167)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_480",
    "data-name": "Pfad 480",
    d: "M-486.653-18.554l10.738,15.335h-.156l-10.581-15.112Z",
    transform: "translate(486.653 23.906)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_481",
    "data-name": "Pfad 481",
    d: "M-486.653-20.516l10.894,15.558h-.156l-10.738-15.335Z",
    transform: "translate(486.653 25.645)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_482",
    "data-name": "Pfad 482",
    d: "M-486.653-22.479-475.6-6.7h-.156l-10.894-15.558Z",
    transform: "translate(486.653 27.384)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_483",
    "data-name": "Pfad 483",
    d: "M-486.653-24.441l11.206,16h-.156l-11.05-15.781Z",
    transform: "translate(486.653 29.123)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_484",
    "data-name": "Pfad 484",
    d: "M-486.653-26.4l11.362,16.227h-.156l-11.206-16Z",
    transform: "translate(486.653 30.862)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_485",
    "data-name": "Pfad 485",
    d: "M-486.653-28.365l11.519,16.45h-.156l-11.362-16.227Z",
    transform: "translate(486.653 32.602)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_486",
    "data-name": "Pfad 486",
    d: "M-486.653-30.327l11.675,16.674h-.156L-486.653-30.1Z",
    transform: "translate(486.653 34.341)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_487",
    "data-name": "Pfad 487",
    d: "M-486.653-32.29l11.831,16.9h-.156l-11.675-16.674Z",
    transform: "translate(486.653 36.08)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_488",
    "data-name": "Pfad 488",
    d: "M-486.653-34.252l11.987,17.12h-.156l-11.831-16.9Z",
    transform: "translate(486.653 37.819)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_489",
    "data-name": "Pfad 489",
    d: "M-486.653-36.214l12.143,17.343h-.156l-11.987-17.12Z",
    transform: "translate(486.653 39.558)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_490",
    "data-name": "Pfad 490",
    d: "M-486.653-38.176l12.3,17.566h-.156l-12.143-17.343Z",
    transform: "translate(486.653 41.297)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_491",
    "data-name": "Pfad 491",
    d: "M-486.653-40.138-474.2-22.349h-.156l-12.3-17.566Z",
    transform: "translate(486.653 43.036)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_492",
    "data-name": "Pfad 492",
    d: "M-486.653-41.822l.021-.015,12.591,17.982h-.156l-12.456-17.789Z",
    transform: "translate(486.653 44.541)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_493",
    "data-name": "Pfad 493",
    d: "M-486.468-42.409l.1-.073,12.643,18.055h-.156Z",
    transform: "translate(486.489 45.113)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_494",
    "data-name": "Pfad 494",
    d: "M-485.546-43.054l.1-.073L-472.747-25h-.156Z",
    transform: "translate(485.672 45.685)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_495",
    "data-name": "Pfad 495",
    d: "M-484.624-43.7l.1-.073,12.745,18.2h-.156Z",
    transform: "translate(484.855 46.258)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_496",
    "data-name": "Pfad 496",
    d: "M-483.7-44.345l.1-.073,12.8,18.276h-.156Z",
    transform: "translate(484.038 46.83)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_497",
    "data-name": "Pfad 497",
    d: "M-482.78-44.991l.1-.073,12.848,18.349h-.156Z",
    transform: "translate(483.221 47.402)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_498",
    "data-name": "Pfad 498",
    d: "M-481.858-45.636l.1-.073,12.9,18.422h-.156Z",
    transform: "translate(482.403 47.974)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_499",
    "data-name": "Pfad 499",
    d: "M-480.936-46.282l.1-.073,12.951,18.5h-.156Z",
    transform: "translate(481.586 48.546)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_500",
    "data-name": "Pfad 500",
    d: "M-480.014-46.927l.1-.073,13,18.569h-.156Z",
    transform: "translate(480.769 49.118)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_501",
    "data-name": "Pfad 501",
    d: "M-479.093-47.573l.1-.073L-465.934-29h-.156Z",
    transform: "translate(479.952 49.691)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_502",
    "data-name": "Pfad 502",
    d: "M-478.171-48.218l.1-.073,13.105,18.716h-.156Z",
    transform: "translate(479.135 50.263)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_503",
    "data-name": "Pfad 503",
    d: "M-477.249-48.864l.1-.073,13.156,18.789h-.156Z",
    transform: "translate(478.318 50.835)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_504",
    "data-name": "Pfad 504",
    d: "M-476.327-49.51l.1-.073,13.208,18.863h-.156Z",
    transform: "translate(477.501 51.407)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_505",
    "data-name": "Pfad 505",
    d: "M-475.4-50.155l.1-.073,13.259,18.936h-.156Z",
    transform: "translate(476.684 51.979)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_506",
    "data-name": "Pfad 506",
    d: "M-474.483-50.8l.1-.073,13.311,19.01h-.156Z",
    transform: "translate(475.866 52.551)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_507",
    "data-name": "Pfad 507",
    d: "M-473.561-51.446l.1-.073,13.362,19.083h-.156Z",
    transform: "translate(475.049 53.124)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_508",
    "data-name": "Pfad 508",
    d: "M-472.639-52.092l.1-.073,13.413,19.156h-.156Z",
    transform: "translate(474.232 53.696)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_509",
    "data-name": "Pfad 509",
    d: "M-471.717-52.737l.1-.073,13.465,19.23h-.156Z",
    transform: "translate(473.415 54.268)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_510",
    "data-name": "Pfad 510",
    d: "M-470.795-53.383l.1-.073,13.516,19.3h-.156Z",
    transform: "translate(472.598 54.84)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_511",
    "data-name": "Pfad 511",
    d: "M-469.873-54.028l.1-.073L-456.2-34.725h-.156Z",
    transform: "translate(471.781 55.412)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_512",
    "data-name": "Pfad 512",
    d: "M-468.951-54.674l.1-.073,13.619,19.45h-.156Z",
    transform: "translate(470.964 55.984)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_513",
    "data-name": "Pfad 513",
    d: "M-468.029-55.32l.1-.073,13.67,19.523h-.156Z",
    transform: "translate(470.147 56.556)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_514",
    "data-name": "Pfad 514",
    d: "M-467.107-55.965l.1-.073,13.722,19.6h-.156Z",
    transform: "translate(469.329 57.129)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_515",
    "data-name": "Pfad 515",
    d: "M-466.185-56.611l.1-.073,13.773,19.67h-.156Z",
    transform: "translate(468.512 57.701)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_516",
    "data-name": "Pfad 516",
    d: "M-465.263-57.256l.1-.073,13.824,19.743h-.156Z",
    transform: "translate(467.695 58.273)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_517",
    "data-name": "Pfad 517",
    d: "M-464.341-57.9l.1-.073,13.876,19.817h-.156Z",
    transform: "translate(466.878 58.845)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_518",
    "data-name": "Pfad 518",
    d: "M-463.42-58.187l.039-.027,13.895,19.844h-.058Z",
    transform: "translate(466.061 59.057)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_519",
    "data-name": "Pfad 519",
    d: "M-463.078-58.426l.039-.027,13.914,19.871h-.058Z",
    transform: "translate(465.759 59.268)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_520",
    "data-name": "Pfad 520",
    d: "M-462.737-58.664l.039-.027,13.933,19.9h-.058Z",
    transform: "translate(465.456 59.48)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_521",
    "data-name": "Pfad 521",
    d: "M-462.4-58.9l.039-.027L-448.406-39h-.058Z",
    transform: "translate(465.154 59.692)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_522",
    "data-name": "Pfad 522",
    d: "M-462.055-59.142l.039-.027,13.97,19.951,0,0h-.054Z",
    transform: "translate(464.852 59.903)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_101",
    "data-name": "Rechteck 101",
    width: 0.047,
    height: 24.356,
    transform: "translate(2.835 0.734) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_102",
    "data-name": "Rechteck 102",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 2.874, 0.707)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_103",
    "data-name": "Rechteck 103",
    width: 0.047,
    height: 24.356,
    transform: "translate(2.913 0.68) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_104",
    "data-name": "Rechteck 104",
    width: 0.047,
    height: 24.356,
    transform: "translate(2.952 0.653) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_105",
    "data-name": "Rechteck 105",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 2.991, 0.626)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_106",
    "data-name": "Rechteck 106",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 3.029, 0.598)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_107",
    "data-name": "Rechteck 107",
    width: 0.047,
    height: 24.356,
    transform: "translate(3.068 0.571) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_108",
    "data-name": "Rechteck 108",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 3.107, 0.544)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_109",
    "data-name": "Rechteck 109",
    width: 0.047,
    height: 24.356,
    transform: "translate(3.146 0.517) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_110",
    "data-name": "Rechteck 110",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 3.184, 0.49)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_111",
    "data-name": "Rechteck 111",
    width: 0.047,
    height: 24.356,
    transform: "translate(3.223 0.463) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_112",
    "data-name": "Rechteck 112",
    width: 0.047,
    height: 24.356,
    transform: "translate(3.262 0.436) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_113",
    "data-name": "Rechteck 113",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 3.301, 0.408)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_114",
    "data-name": "Rechteck 114",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 3.34, 0.381)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_115",
    "data-name": "Rechteck 115",
    width: 0.047,
    height: 24.356,
    transform: "translate(3.378 0.354) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_116",
    "data-name": "Rechteck 116",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 3.417, 0.327)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_117",
    "data-name": "Rechteck 117",
    width: 0.047,
    height: 24.356,
    transform: "translate(3.456 0.3) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_118",
    "data-name": "Rechteck 118",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 3.495, 0.273)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_119",
    "data-name": "Rechteck 119",
    width: 0.047,
    height: 24.356,
    transform: "translate(3.533 0.245) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_120",
    "data-name": "Rechteck 120",
    width: 0.047,
    height: 24.356,
    transform: "translate(3.572 0.218) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_121",
    "data-name": "Rechteck 121",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 3.611, 0.191)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_122",
    "data-name": "Rechteck 122",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 3.65, 0.164)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_123",
    "data-name": "Rechteck 123",
    width: 0.047,
    height: 24.356,
    transform: "translate(3.689 0.137) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_124",
    "data-name": "Rechteck 124",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 3.727, 0.11)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_125",
    "data-name": "Rechteck 125",
    width: 0.047,
    height: 24.356,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 3.766, 0.083)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_126",
    "data-name": "Rechteck 126",
    width: 0.047,
    height: 24.356,
    transform: "translate(3.805 0.055) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_127",
    "data-name": "Rechteck 127",
    width: 0.047,
    height: 24.356,
    transform: "translate(3.844 0.028) rotate(-35)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_523",
    "data-name": "Pfad 523",
    d: "M-452.5-65.626h.057L-438.5-45.7l-.039.027Z",
    transform: "translate(456.387 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_524",
    "data-name": "Pfad 524",
    d: "M-451.945-65.627l13.932,19.9-.039.027L-452-65.627Z",
    transform: "translate(455.942 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_525",
    "data-name": "Pfad 525",
    d: "M-451.437-65.627l13.913,19.871-.039.027-13.933-19.9Z",
    transform: "translate(455.492 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_526",
    "data-name": "Pfad 526",
    d: "M-450.929-65.627l13.895,19.843-.039.027-13.914-19.871Z",
    transform: "translate(455.041 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_527",
    "data-name": "Pfad 527",
    d: "M-450.42-65.627l13.875,19.816-.039.027-13.895-19.843Z",
    transform: "translate(454.591 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_528",
    "data-name": "Pfad 528",
    d: "M-449.912-65.627l13.856,19.789-.039.027L-449.97-65.627Z",
    transform: "translate(454.14 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_529",
    "data-name": "Pfad 529",
    d: "M-449.4-65.627l13.837,19.762-.039.027-13.856-19.789Z",
    transform: "translate(453.69 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_530",
    "data-name": "Pfad 530",
    d: "M-448.9-65.627l13.819,19.735-.039.027-13.837-19.762Z",
    transform: "translate(453.239 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_531",
    "data-name": "Pfad 531",
    d: "M-448.387-65.627l13.8,19.708-.039.027-13.818-19.735Z",
    transform: "translate(452.789 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_532",
    "data-name": "Pfad 532",
    d: "M-447.879-65.627l13.78,19.681-.039.027-13.8-19.708Z",
    transform: "translate(452.338 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_533",
    "data-name": "Pfad 533",
    d: "M-447.37-65.627l13.761,19.653-.039.027-13.78-19.681Z",
    transform: "translate(451.888 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_534",
    "data-name": "Pfad 534",
    d: "M-446.862-65.627-433.12-46l-.039.027L-446.92-65.627Z",
    transform: "translate(451.437 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_535",
    "data-name": "Pfad 535",
    d: "M-446.354-65.627l13.723,19.6-.039.027-13.742-19.626Z",
    transform: "translate(450.987 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_536",
    "data-name": "Pfad 536",
    d: "M-445.846-65.627l13.7,19.572-.039.027-13.723-19.6Z",
    transform: "translate(450.536 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_537",
    "data-name": "Pfad 537",
    d: "M-445.337-65.627l13.685,19.545-.039.027-13.7-19.572Z",
    transform: "translate(450.086 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_538",
    "data-name": "Pfad 538",
    d: "M-444.829-65.627l13.666,19.518-.039.027-13.685-19.545Z",
    transform: "translate(449.635 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_539",
    "data-name": "Pfad 539",
    d: "M-444.321-65.627l13.647,19.49-.039.027-13.666-19.518Z",
    transform: "translate(449.185 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_540",
    "data-name": "Pfad 540",
    d: "M-443.812-65.627l13.628,19.463-.039.027-13.647-19.49Z",
    transform: "translate(448.734 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_541",
    "data-name": "Pfad 541",
    d: "M-443.3-65.627l13.609,19.436-.039.027-13.628-19.463Z",
    transform: "translate(448.284 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_542",
    "data-name": "Pfad 542",
    d: "M-442.8-65.627l13.59,19.409-.039.027-13.609-19.436Z",
    transform: "translate(447.833 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_543",
    "data-name": "Pfad 543",
    d: "M-442.287-65.627l13.571,19.382-.039.027-13.59-19.409Z",
    transform: "translate(447.383 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_544",
    "data-name": "Pfad 544",
    d: "M-441.779-65.627l13.552,19.355-.039.027-13.571-19.382Z",
    transform: "translate(446.932 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_545",
    "data-name": "Pfad 545",
    d: "M-441.271-65.627-427.738-46.3l-.039.027-13.552-19.355Z",
    transform: "translate(446.482 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_546",
    "data-name": "Pfad 546",
    d: "M-440.762-65.627l13.514,19.3-.039.027L-440.82-65.627Z",
    transform: "translate(446.031 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_547",
    "data-name": "Pfad 547",
    d: "M-440.254-65.627l13.5,19.273-.039.027-13.514-19.3Z",
    transform: "translate(445.581 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_548",
    "data-name": "Pfad 548",
    d: "M-439.746-65.627l13.476,19.246-.039.027-13.5-19.273Z",
    transform: "translate(445.13 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_549",
    "data-name": "Pfad 549",
    d: "M-439.237-65.627l13.457,19.219-.039.027L-439.3-65.627Z",
    transform: "translate(444.68 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_550",
    "data-name": "Pfad 550",
    d: "M-438.729-65.627l13.438,19.192-.039.027-13.457-19.219Z",
    transform: "translate(444.229 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_551",
    "data-name": "Pfad 551",
    d: "M-438.221-65.627-424.8-46.462l-.039.027-13.438-19.192Z",
    transform: "translate(443.778 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_552",
    "data-name": "Pfad 552",
    d: "M-437.713-65.627l13.4,19.137-.039.027L-437.77-65.627Z",
    transform: "translate(443.328 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_553",
    "data-name": "Pfad 553",
    d: "M-437.2-65.627l13.381,19.11-.039.027-13.4-19.137Z",
    transform: "translate(442.878 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_554",
    "data-name": "Pfad 554",
    d: "M-436.7-65.627l13.362,19.083-.039.027-13.381-19.11Z",
    transform: "translate(442.427 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_555",
    "data-name": "Pfad 555",
    d: "M-436.188-65.627l13.343,19.056-.039.027-13.362-19.083Z",
    transform: "translate(441.976 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_556",
    "data-name": "Pfad 556",
    d: "M-435.679-65.627-422.355-46.6l-.039.027-13.343-19.056Z",
    transform: "translate(441.526 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_557",
    "data-name": "Pfad 557",
    d: "M-435.171-65.627l13.305,19-.039.027-13.324-19.029Z",
    transform: "translate(441.075 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_558",
    "data-name": "Pfad 558",
    d: "M-434.663-65.627l13.286,18.975-.039.027-13.305-19Z",
    transform: "translate(440.625 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_559",
    "data-name": "Pfad 559",
    d: "M-434.154-65.627l13.267,18.947-.039.027-13.286-18.975Z",
    transform: "translate(440.174 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_560",
    "data-name": "Pfad 560",
    d: "M-433.646-65.627l13.248,18.92-.039.027L-433.7-65.627Z",
    transform: "translate(439.724 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_561",
    "data-name": "Pfad 561",
    d: "M-433.138-65.627l13.229,18.893-.039.027L-433.2-65.627Z",
    transform: "translate(439.273 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_562",
    "data-name": "Pfad 562",
    d: "M-432.629-65.627l13.21,18.866-.039.027-13.229-18.893Z",
    transform: "translate(438.823 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_563",
    "data-name": "Pfad 563",
    d: "M-432.121-65.627l13.191,18.839-.039.027-13.21-18.866Z",
    transform: "translate(438.372 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_564",
    "data-name": "Pfad 564",
    d: "M-431.613-65.627l13.172,18.812-.039.027-13.191-18.839Z",
    transform: "translate(437.922 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_565",
    "data-name": "Pfad 565",
    d: "M-431.1-65.627l13.153,18.784-.039.027-13.172-18.812Z",
    transform: "translate(437.471 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_566",
    "data-name": "Pfad 566",
    d: "M-430.6-65.627l13.134,18.757-.039.027-13.153-18.784Z",
    transform: "translate(437.021 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_567",
    "data-name": "Pfad 567",
    d: "M-430.088-65.627l13.115,18.73-.039.027-13.134-18.757Z",
    transform: "translate(436.57 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_568",
    "data-name": "Pfad 568",
    d: "M-429.58-65.627l13.1,18.7-.039.027-13.115-18.73Z",
    transform: "translate(436.12 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_569",
    "data-name": "Pfad 569",
    d: "M-429.071-65.627l13.077,18.676-.039.027-13.1-18.7Z",
    transform: "translate(435.669 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_570",
    "data-name": "Pfad 570",
    d: "M-428.563-65.627l13.058,18.649-.039.027-13.077-18.676Z",
    transform: "translate(435.219 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_571",
    "data-name": "Pfad 571",
    d: "M-428.055-65.627l13.039,18.622-.039.027-13.058-18.649Z",
    transform: "translate(434.768 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_572",
    "data-name": "Pfad 572",
    d: "M-427.546-65.627l13.02,18.594-.039.027L-427.6-65.627Z",
    transform: "translate(434.318 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_573",
    "data-name": "Pfad 573",
    d: "M-427.038-65.627l13,18.567-.039.027L-427.1-65.627Z",
    transform: "translate(433.867 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_574",
    "data-name": "Pfad 574",
    d: "M-426.53-65.627l12.982,18.54-.039.027-13-18.567Z",
    transform: "translate(433.417 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_575",
    "data-name": "Pfad 575",
    d: "M-426.021-65.627l12.963,18.513-.039.027-12.982-18.54Z",
    transform: "translate(432.966 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_576",
    "data-name": "Pfad 576",
    d: "M-425.513-65.627l12.944,18.486-.039.027-12.963-18.513Z",
    transform: "translate(432.516 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_577",
    "data-name": "Pfad 577",
    d: "M-425-65.627l12.925,18.459-.039.027-12.944-18.486Z",
    transform: "translate(432.065 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_578",
    "data-name": "Pfad 578",
    d: "M-424.5-65.627-411.591-47.2l-.039.027-12.925-18.459Z",
    transform: "translate(431.615 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_579",
    "data-name": "Pfad 579",
    d: "M-423.988-65.627l12.887,18.4-.039.027-12.906-18.431Z",
    transform: "translate(431.164 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_580",
    "data-name": "Pfad 580",
    d: "M-423.48-65.627l12.868,18.377-.039.027-12.887-18.4Z",
    transform: "translate(430.713 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_581",
    "data-name": "Pfad 581",
    d: "M-422.972-65.627l12.849,18.35-.039.027-12.868-18.377Z",
    transform: "translate(430.263 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_582",
    "data-name": "Pfad 582",
    d: "M-422.463-65.627l12.83,18.323-.039.027-12.849-18.35Z",
    transform: "translate(429.813 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_583",
    "data-name": "Pfad 583",
    d: "M-421.955-65.627l12.811,18.3-.039.027-12.83-18.323Z",
    transform: "translate(429.362 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_584",
    "data-name": "Pfad 584",
    d: "M-421.447-65.627l12.792,18.269-.039.027-12.811-18.3Z",
    transform: "translate(428.911 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_585",
    "data-name": "Pfad 585",
    d: "M-420.938-65.627l12.773,18.241-.039.027L-421-65.627Z",
    transform: "translate(428.461 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_586",
    "data-name": "Pfad 586",
    d: "M-420.43-65.627l12.754,18.214-.039.027-12.773-18.241Z",
    transform: "translate(428.01 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_587",
    "data-name": "Pfad 587",
    d: "M-419.922-65.627l12.735,18.187-.039.027L-419.98-65.627Z",
    transform: "translate(427.56 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_588",
    "data-name": "Pfad 588",
    d: "M-419.413-65.627l12.716,18.16-.039.027-12.735-18.187Z",
    transform: "translate(427.109 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_589",
    "data-name": "Pfad 589",
    d: "M-418.905-65.627l12.7,18.133-.039.027-12.716-18.16Z",
    transform: "translate(426.659 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_590",
    "data-name": "Pfad 590",
    d: "M-418.4-65.627l12.678,18.106-.039.027-12.7-18.133Z",
    transform: "translate(426.208 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_591",
    "data-name": "Pfad 591",
    d: "M-417.888-65.627l12.659,18.078-.039.027-12.678-18.106Z",
    transform: "translate(425.758 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_592",
    "data-name": "Pfad 592",
    d: "M-417.38-65.627l12.64,18.051-.039.027-12.659-18.078Z",
    transform: "translate(425.307 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_593",
    "data-name": "Pfad 593",
    d: "M-416.872-65.627-404.251-47.6l-.039.027-12.64-18.051Z",
    transform: "translate(424.857 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_594",
    "data-name": "Pfad 594",
    d: "M-416.364-65.627l12.6,18-.039.027-12.621-18.024Z",
    transform: "translate(424.406 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_595",
    "data-name": "Pfad 595",
    d: "M-415.855-65.627l12.583,17.97-.039.027-12.6-18Z",
    transform: "translate(423.956 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_596",
    "data-name": "Pfad 596",
    d: "M-415.347-65.627l12.529,17.893v.075l0,0L-415.4-65.627Z",
    transform: "translate(423.505 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_597",
    "data-name": "Pfad 597",
    d: "M-414.839-65.627l12.471,17.81v.083L-414.9-65.627Z",
    transform: "translate(423.055 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_598",
    "data-name": "Pfad 598",
    d: "M-414.33-65.627-401.917-47.9v.083l-12.471-17.81Z",
    transform: "translate(422.604 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_599",
    "data-name": "Pfad 599",
    d: "M-413.822-65.627l12.355,17.645v.083L-413.88-65.627Z",
    transform: "translate(422.154 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_600",
    "data-name": "Pfad 600",
    d: "M-413.314-65.627l12.3,17.563v.083l-12.355-17.645Z",
    transform: "translate(421.703 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_601",
    "data-name": "Pfad 601",
    d: "M-412.805-65.627l12.24,17.48v.083l-12.3-17.563Z",
    transform: "translate(421.253 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_602",
    "data-name": "Pfad 602",
    d: "M-412.3-65.627l12.182,17.4v.083l-12.24-17.48Z",
    transform: "translate(420.802 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_603",
    "data-name": "Pfad 603",
    d: "M-411.789-65.627l12.124,17.315v.083l-12.182-17.4Z",
    transform: "translate(420.352 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_604",
    "data-name": "Pfad 604",
    d: "M-411.281-65.627l12.066,17.232v.083l-12.124-17.315Z",
    transform: "translate(419.901 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_605",
    "data-name": "Pfad 605",
    d: "M-410.772-65.627l12.008,17.15v.083L-410.83-65.627Z",
    transform: "translate(419.451 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_606",
    "data-name": "Pfad 606",
    d: "M-410.264-65.627l11.951,17.067v.083l-12.008-17.15Z",
    transform: "translate(419 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_607",
    "data-name": "Pfad 607",
    d: "M-409.756-65.627l11.893,16.985v.083l-11.951-17.067Z",
    transform: "translate(418.55 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_608",
    "data-name": "Pfad 608",
    d: "M-409.247-65.627l11.835,16.9v.083l-11.893-16.985Z",
    transform: "translate(418.099 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_609",
    "data-name": "Pfad 609",
    d: "M-408.739-65.627l11.777,16.82v.083l-11.835-16.9Z",
    transform: "translate(417.648 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_610",
    "data-name": "Pfad 610",
    d: "M-408.231-65.627l11.719,16.737v.083l-11.777-16.82Z",
    transform: "translate(417.198 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_611",
    "data-name": "Pfad 611",
    d: "M-407.722-65.627l11.662,16.655v.083L-407.78-65.627Z",
    transform: "translate(416.747 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_612",
    "data-name": "Pfad 612",
    d: "M-407.214-65.627l11.6,16.572v.083l-11.662-16.655Z",
    transform: "translate(416.297 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_613",
    "data-name": "Pfad 613",
    d: "M-406.706-65.627l11.546,16.49v.083l-11.6-16.572Z",
    transform: "translate(415.846 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_614",
    "data-name": "Pfad 614",
    d: "M-406.2-65.627l11.488,16.407v.083l-11.546-16.49Z",
    transform: "translate(415.396 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_615",
    "data-name": "Pfad 615",
    d: "M-405.689-65.627-394.259-49.3v.083l-11.488-16.407Z",
    transform: "translate(414.945 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_616",
    "data-name": "Pfad 616",
    d: "M-405.181-65.627l11.373,16.242v.083l-11.431-16.324Z",
    transform: "translate(414.495 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_617",
    "data-name": "Pfad 617",
    d: "M-404.672-65.627l11.315,16.159v.083L-404.73-65.627Z",
    transform: "translate(414.044 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_618",
    "data-name": "Pfad 618",
    d: "M-404.164-65.627l11.257,16.077v.083l-11.315-16.159Z",
    transform: "translate(413.594 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_619",
    "data-name": "Pfad 619",
    d: "M-403.656-65.627l11.2,15.994v.083l-11.257-16.077Z",
    transform: "translate(413.143 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_620",
    "data-name": "Pfad 620",
    d: "M-403.148-65.627l11.142,15.912v.083l-11.2-15.994Z",
    transform: "translate(412.693 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_621",
    "data-name": "Pfad 621",
    d: "M-402.639-65.627-391.555-49.8v.083L-402.7-65.627Z",
    transform: "translate(412.242 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_622",
    "data-name": "Pfad 622",
    d: "M-402.131-65.627-391.1-49.88v.083l-11.084-15.829Z",
    transform: "translate(411.792 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_623",
    "data-name": "Pfad 623",
    d: "M-401.623-65.627l10.968,15.664v.083L-401.68-65.627Z",
    transform: "translate(411.341 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_624",
    "data-name": "Pfad 624",
    d: "M-401.114-65.627l10.91,15.582v.083l-10.968-15.664Z",
    transform: "translate(410.891 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_625",
    "data-name": "Pfad 625",
    d: "M-400.606-65.627l10.853,15.5v.083l-10.91-15.582Z",
    transform: "translate(410.44 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_626",
    "data-name": "Pfad 626",
    d: "M-400.1-65.627-389.3-50.21v.083l-10.853-15.5Z",
    transform: "translate(409.99 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_627",
    "data-name": "Pfad 627",
    d: "M-399.589-65.627l10.737,15.334v.083l-10.795-15.417Z",
    transform: "translate(409.539 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_628",
    "data-name": "Pfad 628",
    d: "M-399.081-65.627-388.4-50.375v.083l-10.737-15.334Z",
    transform: "translate(409.089 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_629",
    "data-name": "Pfad 629",
    d: "M-398.573-65.627l10.621,15.169v.083l-10.679-15.252Z",
    transform: "translate(408.638 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_630",
    "data-name": "Pfad 630",
    d: "M-398.064-65.627-387.5-50.54v.083l-10.621-15.169Z",
    transform: "translate(408.188 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_631",
    "data-name": "Pfad 631",
    d: "M-397.556-65.627l10.506,15v.083l-10.564-15.086Z",
    transform: "translate(407.737 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_632",
    "data-name": "Pfad 632",
    d: "M-397.048-65.627-386.6-50.705v.083l-10.506-15Z",
    transform: "translate(407.287 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_633",
    "data-name": "Pfad 633",
    d: "M-396.539-65.627l10.39,14.839v.083L-396.6-65.627Z",
    transform: "translate(406.836 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_634",
    "data-name": "Pfad 634",
    d: "M-396.031-65.627-385.7-50.87v.083l-10.39-14.839Z",
    transform: "translate(406.385 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_635",
    "data-name": "Pfad 635",
    d: "M-395.523-65.627l10.275,14.674v.083l-10.332-14.756Z",
    transform: "translate(405.935 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_636",
    "data-name": "Pfad 636",
    d: "M-395.015-65.627-384.8-51.036v.083l-10.275-14.674Z",
    transform: "translate(405.484 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_637",
    "data-name": "Pfad 637",
    d: "M-394.506-65.627l10.159,14.509v.083l-10.217-14.591Z",
    transform: "translate(405.034 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_638",
    "data-name": "Pfad 638",
    d: "M-394-65.627-383.9-51.2v.083l-10.159-14.509Z",
    transform: "translate(404.583 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_639",
    "data-name": "Pfad 639",
    d: "M-393.49-65.627l10.044,14.344v.083l-10.1-14.426Z",
    transform: "translate(404.133 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_640",
    "data-name": "Pfad 640",
    d: "M-392.981-65.627-383-51.366v.083l-10.043-14.344Z",
    transform: "translate(403.682 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_641",
    "data-name": "Pfad 641",
    d: "M-392.473-65.627l9.928,14.179v.083l-9.986-14.261Z",
    transform: "translate(403.232 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_642",
    "data-name": "Pfad 642",
    d: "M-391.965-65.627l9.87,14.1v.083l-9.928-14.179Z",
    transform: "translate(402.781 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_643",
    "data-name": "Pfad 643",
    d: "M-391.456-65.627l9.812,14.014v.083l-9.87-14.1Z",
    transform: "translate(402.331 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_644",
    "data-name": "Pfad 644",
    d: "M-390.948-65.627l9.755,13.931v.083l-9.812-14.014Z",
    transform: "translate(401.88 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_645",
    "data-name": "Pfad 645",
    d: "M-390.44-65.627l9.7,13.848v.083L-390.5-65.627Z",
    transform: "translate(401.43 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_646",
    "data-name": "Pfad 646",
    d: "M-389.931-65.627l9.639,13.766v.083l-9.7-13.848Z",
    transform: "translate(400.979 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_647",
    "data-name": "Pfad 647",
    d: "M-389.423-65.627l9.581,13.683v.083l-9.639-13.766Z",
    transform: "translate(400.529 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_648",
    "data-name": "Pfad 648",
    d: "M-388.915-65.627l9.523,13.6v.083l-9.581-13.683Z",
    transform: "translate(400.078 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_649",
    "data-name": "Pfad 649",
    d: "M-388.407-65.627l9.466,13.518v.083l-9.523-13.6Z",
    transform: "translate(399.628 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_650",
    "data-name": "Pfad 650",
    d: "M-387.9-65.627l9.408,13.436v.083l-9.466-13.518Z",
    transform: "translate(399.177 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_651",
    "data-name": "Pfad 651",
    d: "M-387.39-65.627l9.35,13.353v.083l-9.408-13.436Z",
    transform: "translate(398.727 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_652",
    "data-name": "Pfad 652",
    d: "M-386.882-65.627l9.292,13.271v.083l-9.35-13.353Z",
    transform: "translate(398.276 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_653",
    "data-name": "Pfad 653",
    d: "M-386.373-65.627l9.234,13.188v.083l-9.292-13.271Z",
    transform: "translate(397.826 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_654",
    "data-name": "Pfad 654",
    d: "M-385.865-65.627l9.177,13.106v.083l-9.234-13.188Z",
    transform: "translate(397.375 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_655",
    "data-name": "Pfad 655",
    d: "M-385.357-65.627l9.119,13.023v.083l-9.177-13.106Z",
    transform: "translate(396.925 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_656",
    "data-name": "Pfad 656",
    d: "M-384.848-65.627l9.061,12.941v.083l-9.119-13.023Z",
    transform: "translate(396.474 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_657",
    "data-name": "Pfad 657",
    d: "M-384.34-65.627l9,12.858v.083L-384.4-65.627Z",
    transform: "translate(396.024 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_658",
    "data-name": "Pfad 658",
    d: "M-383.832-65.627l8.945,12.776v.083l-9-12.858Z",
    transform: "translate(395.573 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_659",
    "data-name": "Pfad 659",
    d: "M-383.323-65.627l8.888,12.693v.083l-8.945-12.776Z",
    transform: "translate(395.123 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_660",
    "data-name": "Pfad 660",
    d: "M-382.815-65.627l8.83,12.61v.083l-8.888-12.693Z",
    transform: "translate(394.672 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_661",
    "data-name": "Pfad 661",
    d: "M-382.307-65.627l8.772,12.528v.083l-8.83-12.61Z",
    transform: "translate(394.221 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_662",
    "data-name": "Pfad 662",
    d: "M-381.8-65.627l8.714,12.445v.083l-8.772-12.528Z",
    transform: "translate(393.771 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_663",
    "data-name": "Pfad 663",
    d: "M-381.29-65.627l8.657,12.363v.083l-8.714-12.445Z",
    transform: "translate(393.32 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_664",
    "data-name": "Pfad 664",
    d: "M-380.782-65.627l8.6,12.28v.083l-8.656-12.363Z",
    transform: "translate(392.87 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_665",
    "data-name": "Pfad 665",
    d: "M-380.274-65.627l8.541,12.2v.083l-8.6-12.28Z",
    transform: "translate(392.419 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_666",
    "data-name": "Pfad 666",
    d: "M-379.765-65.627l8.483,12.115v.083l-8.541-12.2Z",
    transform: "translate(391.969 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_667",
    "data-name": "Pfad 667",
    d: "M-379.257-65.627l8.425,12.033v.083l-8.483-12.115Z",
    transform: "translate(391.518 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_668",
    "data-name": "Pfad 668",
    d: "M-378.749-65.627l8.368,11.95v.083l-8.425-12.033Z",
    transform: "translate(391.068 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_669",
    "data-name": "Pfad 669",
    d: "M-378.24-65.627l8.31,11.868v.083l-8.368-11.95Z",
    transform: "translate(390.617 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_670",
    "data-name": "Pfad 670",
    d: "M-377.732-65.627l8.252,11.785v.083l-8.31-11.868Z",
    transform: "translate(390.167 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_671",
    "data-name": "Pfad 671",
    d: "M-377.224-65.627l8.194,11.7v.083l-8.252-11.785Z",
    transform: "translate(389.716 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_672",
    "data-name": "Pfad 672",
    d: "M-376.715-65.627l8.136,11.62v.083l-8.194-11.7Z",
    transform: "translate(389.266 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_673",
    "data-name": "Pfad 673",
    d: "M-376.207-65.627l8.079,11.537v.083l-8.136-11.62Z",
    transform: "translate(388.815 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_674",
    "data-name": "Pfad 674",
    d: "M-375.7-65.627l8.021,11.455v.083l-8.079-11.537Z",
    transform: "translate(388.365 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_675",
    "data-name": "Pfad 675",
    d: "M-375.19-65.627l7.963,11.372v.083l-8.021-11.455Z",
    transform: "translate(387.914 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_676",
    "data-name": "Pfad 676",
    d: "M-374.682-65.627l7.905,11.29v.083l-7.963-11.372Z",
    transform: "translate(387.464 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_677",
    "data-name": "Pfad 677",
    d: "M-374.174-65.627l7.847,11.207v.083l-7.905-11.29Z",
    transform: "translate(387.013 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_678",
    "data-name": "Pfad 678",
    d: "M-373.666-65.627l7.79,11.125v.083l-7.847-11.207Z",
    transform: "translate(386.563 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_679",
    "data-name": "Pfad 679",
    d: "M-373.157-65.627l7.732,11.042v.083l-7.79-11.125Z",
    transform: "translate(386.112 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_680",
    "data-name": "Pfad 680",
    d: "M-372.649-65.627l7.674,10.96v.083l-7.732-11.042Z",
    transform: "translate(385.662 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_681",
    "data-name": "Pfad 681",
    d: "M-372.141-65.627l7.616,10.877v.083l-7.674-10.96Z",
    transform: "translate(385.211 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_682",
    "data-name": "Pfad 682",
    d: "M-371.632-65.627l7.558,10.795v.083l-7.616-10.877Z",
    transform: "translate(384.761 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_683",
    "data-name": "Pfad 683",
    d: "M-371.124-65.627l7.5,10.712v.083l-7.559-10.795Z",
    transform: "translate(384.31 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_684",
    "data-name": "Pfad 684",
    d: "M-370.616-65.627-363.173-55v.083l-7.5-10.712Z",
    transform: "translate(383.86 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_685",
    "data-name": "Pfad 685",
    d: "M-370.107-65.627l7.385,10.547V-55l-7.443-10.63Z",
    transform: "translate(383.409 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_686",
    "data-name": "Pfad 686",
    d: "M-369.6-65.627l7.327,10.465v.083l-7.385-10.547Z",
    transform: "translate(382.958 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_687",
    "data-name": "Pfad 687",
    d: "M-369.091-65.627l7.269,10.382v.083l-7.327-10.465Z",
    transform: "translate(382.508 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_688",
    "data-name": "Pfad 688",
    d: "M-368.582-65.627l7.212,10.3v.083l-7.27-10.382Z",
    transform: "translate(382.057 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_689",
    "data-name": "Pfad 689",
    d: "M-368.074-65.627l7.154,10.217v.083l-7.212-10.3Z",
    transform: "translate(381.607 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_690",
    "data-name": "Pfad 690",
    d: "M-367.566-65.627l7.1,10.134v.083l-7.154-10.217Z",
    transform: "translate(381.156 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_691",
    "data-name": "Pfad 691",
    d: "M-367.058-65.627l7.038,10.052v.083l-7.1-10.134Z",
    transform: "translate(380.706 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_692",
    "data-name": "Pfad 692",
    d: "M-366.549-65.627l6.981,9.969v.083l-7.038-10.052Z",
    transform: "translate(380.255 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_693",
    "data-name": "Pfad 693",
    d: "M-366.041-65.627l6.923,9.887v.083l-6.981-9.969Z",
    transform: "translate(379.805 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_694",
    "data-name": "Pfad 694",
    d: "M-365.533-65.627l6.865,9.8v.083l-6.923-9.887Z",
    transform: "translate(379.354 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_695",
    "data-name": "Pfad 695",
    d: "M-365.024-65.627l6.807,9.722v.083l-6.865-9.8Z",
    transform: "translate(378.904 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_696",
    "data-name": "Pfad 696",
    d: "M-364.516-65.627l6.749,9.639v.083l-6.807-9.722Z",
    transform: "translate(378.453 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_697",
    "data-name": "Pfad 697",
    d: "M-364.008-65.627l6.692,9.557v.083l-6.749-9.639Z",
    transform: "translate(378.003 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_698",
    "data-name": "Pfad 698",
    d: "M-363.5-65.627l6.634,9.474v.083l-6.692-9.557Z",
    transform: "translate(377.552 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_699",
    "data-name": "Pfad 699",
    d: "M-362.991-65.627l6.576,9.392v.083l-6.634-9.474Z",
    transform: "translate(377.102 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_700",
    "data-name": "Pfad 700",
    d: "M-362.483-65.627l6.518,9.309v.083l-6.576-9.392Z",
    transform: "translate(376.651 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_701",
    "data-name": "Pfad 701",
    d: "M-361.975-65.627l6.461,9.227v.083l-6.518-9.309Z",
    transform: "translate(376.201 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_702",
    "data-name": "Pfad 702",
    d: "M-361.466-65.627l6.4,9.144v.083l-6.46-9.227Z",
    transform: "translate(375.75 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_703",
    "data-name": "Pfad 703",
    d: "M-360.958-65.627l6.345,9.061v.083l-6.4-9.144Z",
    transform: "translate(375.3 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_704",
    "data-name": "Pfad 704",
    d: "M-360.45-65.627l6.287,8.979v.083l-6.345-9.061Z",
    transform: "translate(374.849 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_705",
    "data-name": "Pfad 705",
    d: "M-359.941-65.627l6.229,8.9v.083L-360-65.627Z",
    transform: "translate(374.399 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_706",
    "data-name": "Pfad 706",
    d: "M-359.433-65.627l6.171,8.814v.083l-6.229-8.9Z",
    transform: "translate(373.948 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_707",
    "data-name": "Pfad 707",
    d: "M-358.925-65.627l6.114,8.731v.083l-6.172-8.814Z",
    transform: "translate(373.498 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_708",
    "data-name": "Pfad 708",
    d: "M-358.416-65.627l6.056,8.649v.083l-6.114-8.731Z",
    transform: "translate(373.047 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_709",
    "data-name": "Pfad 709",
    d: "M-357.908-65.627l6,8.566v.083l-6.056-8.649Z",
    transform: "translate(372.597 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_710",
    "data-name": "Pfad 710",
    d: "M-357.4-65.627l5.94,8.484v.083l-6-8.566Z",
    transform: "translate(372.146 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_711",
    "data-name": "Pfad 711",
    d: "M-356.891-65.627l5.883,8.4v.083l-5.94-8.484Z",
    transform: "translate(371.695 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_712",
    "data-name": "Pfad 712",
    d: "M-356.383-65.627l5.825,8.319v.083l-5.883-8.4Z",
    transform: "translate(371.245 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_713",
    "data-name": "Pfad 713",
    d: "M-355.875-65.627l5.767,8.236v.083l-5.825-8.319Z",
    transform: "translate(370.795 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_714",
    "data-name": "Pfad 714",
    d: "M-355.366-65.627l5.709,8.154v.083l-5.767-8.236Z",
    transform: "translate(370.344 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_715",
    "data-name": "Pfad 715",
    d: "M-354.858-65.627l5.651,8.071v.083l-5.709-8.154Z",
    transform: "translate(369.894 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_716",
    "data-name": "Pfad 716",
    d: "M-354.35-65.627l5.594,7.988v.083l-5.651-8.071Z",
    transform: "translate(369.443 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_717",
    "data-name": "Pfad 717",
    d: "M-353.842-65.627l5.536,7.906v.083l-5.594-7.988Z",
    transform: "translate(368.992 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_718",
    "data-name": "Pfad 718",
    d: "M-353.333-65.627l5.478,7.823v.083l-5.536-7.906Z",
    transform: "translate(368.542 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_719",
    "data-name": "Pfad 719",
    d: "M-352.825-65.627l5.42,7.741v.083l-5.478-7.823Z",
    transform: "translate(368.091 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_720",
    "data-name": "Pfad 720",
    d: "M-352.317-65.627l5.362,7.658v.083l-5.42-7.741Z",
    transform: "translate(367.641 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_721",
    "data-name": "Pfad 721",
    d: "M-351.808-65.627l5.3,7.576v.083l-5.362-7.658Z",
    transform: "translate(367.19 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_722",
    "data-name": "Pfad 722",
    d: "M-351.3-65.627l5.247,7.493v.083l-5.3-7.576Z",
    transform: "translate(366.74 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_723",
    "data-name": "Pfad 723",
    d: "M-350.792-65.627l5.189,7.411v.083l-5.247-7.493Z",
    transform: "translate(366.289 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_724",
    "data-name": "Pfad 724",
    d: "M-350.283-65.627l5.131,7.328v.083l-5.189-7.411Z",
    transform: "translate(365.839 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_725",
    "data-name": "Pfad 725",
    d: "M-349.775-65.627l5.073,7.246v.083l-5.131-7.328Z",
    transform: "translate(365.388 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_726",
    "data-name": "Pfad 726",
    d: "M-349.267-65.627l5.016,7.163v.083l-5.073-7.246Z",
    transform: "translate(364.938 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_727",
    "data-name": "Pfad 727",
    d: "M-348.758-65.627l4.958,7.081v.083l-5.016-7.163Z",
    transform: "translate(364.487 65.627)",
    fill: "#50af95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_728",
    "data-name": "Pfad 728",
    d: "M-343.35-58.546l-4.958-7.081h4.958Z",
    transform: "translate(364.037 65.627)",
    fill: "#50af95"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_797",
    "data-name": "Pfad 797",
    d: "M71.977,46.7h0c-.074.006-.458.028-1.314.028-.681,0-1.164-.02-1.334-.028h0c-2.632-.116-4.6-.574-4.6-1.122s1.964-1.006,4.6-1.124v1.79c.172.012.665.041,1.346.041.817,0,1.226-.034,1.3-.041V44.459c2.626.117,4.586.575,4.586,1.122S74.6,46.586,71.974,46.7h0Zm0-2.43v-1.6h3.665V40.23H65.664v2.442h3.664v1.6c-2.978.137-5.218.727-5.218,1.434s2.24,1.3,5.218,1.434v5.132h2.648V47.139c2.971-.137,5.207-.726,5.207-1.432s-2.234-1.3-5.207-1.433h0Zm0,0",
    transform: "translate(625.854 474.249)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.09ea924d42adb96d4ac82854282275f6.svg";
export { ForwardRef as ReactComponent };